export const APP_TYPES = {
    NATIONAL_PEN: 'nationalpen',
    SERVICE_PENS_COM: 'service.pens.com',
    SIMPLY_GOLDSTAR: 'simplygoldstar',
    FOR_TEACHERS_ONLY: 'forteachersonly',
}

export const ERROR_MESSAGES = {
    SESSION_EXPIRED: 'Session is expired!',
    INVALID_ID: 'Invalid Id!',
    SOME_ERROR_OCCURED: 'Some error occured!'
}